/**
 * searchUtils.js
 * Utilities for search index and key term generation.
 */

/**
 * Generates an array of unique lowercase keywords for multimodal search.
 * Includes description, ID (SKU), location, and category terms.
 * 
 * @param {Object} data - Product data
 * @returns {string[]} Unique array of strings for the search_keywords field
 */
export const generateSearchKeywords = (data = {}) => {
    const { 
        name = '',
        description = '', 
        sku = '', 
        location = {}, 
        category = '',
        unit = ''
    } = data;

    const rawTerms = [
        name,
        description,
        sku,
        location?.section || '',
        location?.container || '',
        category || '',
        unit || ''
    ];

    const keywords = new Set();
    const STOP_WORDS = new Set(['the', 'and', 'for', 'with', 'from', 'was', 'this', 'that']);
    
    rawTerms.forEach(term => {
        if (!term) return;
        
        const normalized = String(term)
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .trim();

        if (!normalized) return;

        // Fragment and filter tokens
        const tokens = normalized.split(/[\s\-_/. ]+/).filter(t => 
            t.length >= 3 && !STOP_WORDS.has(t)
        );
        
        tokens.forEach(token => keywords.add(token));
        
        // If the original term is short (like a SKU), we include it full.
        if (normalized.length > 0 && normalized.length <= 15) {
            keywords.add(normalized);
        }
    });

    // Limit the total number of keywords to avoid "Index Bloat"
    return Array.from(keywords).slice(0, 50);
};

